<template>
	<div>
		<h2>{{ $lib.translate('Вы выбрали') }}</h2>
		<br>
		<p v-if="step1.name">{{ $lib.translate('Судья') }}: <b>{{ step1.name.translate.ru.name }}</b></p>
		<p v-if="step1.name2">{{ step1.type === 1 ? $lib.translate('Физ. лицо') : $lib.translate('Компания') }}: <b>{{ step1.name2.translate.ru.name }}</b></p>
		<br>
		<div v-if="step1.relations && step1.relations.length">
			<h2>{{ $lib.translate('Связи') }}</h2>
			<div class="relations">
				<div class="relations__group" v-for="(group, i) in step1.relations" :key="i">
					<div class="relations__item" v-for="(item, j) in group" :key="'' + i + j + item.id">
						<div class="relations__block">
							<div class="relations__name">
								{{ item.translate.ru.name }}<br>
								<b>{{ item.translate.ru.relation_name }}</b><br>
								<span v-if="item.document_date">{{ $lib.translate('Актуально на') }}: {{ item.document_date }}</span><br>
								<span v-if="item.source">{{ $lib.translate('Источник') }}:<br>
									<a :href="item.source" target="_blank">{{ $lib.translate('просмотреть в pdf') }}</a>
								</span>
							</div>
							<div class="relations__documents" v-if="item.type !== 'judge' && item.documents_count" @click="next(group[group.length - 1].id, item)">
								{{ $lib.translate('Найдено документов') }}: <b>{{ item.documents_count }}</b><br>
								<ins>{{ $lib.translate('Посмотреть') }}</ins>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else>
			<h2>{{ $lib.translate('Связей не найдено') }}</h2>
		</div>
	</div>
</template>

<script>

	export default {
		name: 'SearchStep2',

		data () {
			return {
				loading: false,
				pageData: {
					data: [],
					links: {},
					meta: {},
					headers: [],
					page: 0,
					judgeId: null,
					currentType: null,
					currentId: null,
					onChange: this.onChange
				},
				limit: 30,
			}
		},

		computed: {
			step1 () {
				return this.$store.getters.PAGE('step1');
			}
		},

		created () {
			this.pageData = Object.assign({}, this.pageData, this.$store.getters.PAGE('step2'));
		},

		beforeDestroy() {
			this.loading = false;
			this.$store.dispatch('SET_PAGE', {
				page: 'step2',
				data: this.pageData
			});
		},

		watch: {
			'pageData.page': function () {
				this.next();
			}
		},

		methods: {
			next (judgeId, item) {
				if (judgeId) {
					this.pageData.judgeId = judgeId;
				}
				if (item) {
					this.pageData.current = item;
				}
				const apiName = this.pageData.type === 1 ? `${this.$api.urls.documentsPerson}/${this.pageData.judgeId}/${this.pageData.current.id}` : `${this.$api.urls.documentsCompany}/${this.pageData.judgeId}/${this.pageData.current.id}`;
				this.$api.get(apiName, {
					params: {
						page: this.pageData.page,
						limit: this.limit
					}
				}).then((response) => {
					this.pageData.data = response.data.data;
					this.pageData.links = response.data.links;
					this.pageData.meta = response.data.meta;
					this.pageData.headers = [
						{
							text: this.$lib.translate('ID'),
							align: 'left',
							value: 'id'
						},
						{
							text: this.$lib.translate('Дата создания'),
							align: 'left',
							value: 'date'
						},
						{
							text: this.$lib.translate('Истец'),
							align: 'left',
							value: 'plaintiff'
						},
						{
							text: this.$lib.translate('Ответчик'),
							align: 'left',
							value: 'defendant'
						},
						{
							text: this.$lib.translate('UID'),
							align: 'right',
							value: 'uid'
						}
					];
					this.pageData.onChange = this.onChange;
					this.$store.dispatch('SET_PAGE', {
						page: 'step2',
						data: this.pageData
					});
					this.$store.dispatch('SET_STEP', 3);
				});
			},
			onChange (page) {
				this.pageData.page = page;
			}
		}
	}
</script>
